import { render, staticRenderFns } from "./DateOfBirth.vue?vue&type=template&id=d68a8854&scoped=true"
import script from "./DateOfBirth.vue?vue&type=script&lang=js"
export * from "./DateOfBirth.vue?vue&type=script&lang=js"
import style0 from "./DateOfBirth.vue?vue&type=style&index=0&id=d68a8854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68a8854",
  null
  
)

export default component.exports